<!-- dashboard-feature-taxes.component.html -->

<div class="container mt-4 p-0 bg-white">
  <h2 class="mb-4">{{ 'TAX_SETTINGS' | translate }}</h2>

  <div *ngIf="!isTaxFeatureEnabled">
    <p>{{ 'TAX_FEATURE_DISABLED_TEXT' | translate }}</p>
  </div>

  <!-- Tax List -->
  <ul class="list-group" *ngIf="isTaxFeatureEnabled">
    <!-- Display the taxes -->
    <ng-container *ngIf="taxes$ | async as taxes">
      <lh-dashboard-taxes-card
        class="mb-4"
        *ngFor="let tax of taxes; let i = index"
        [taxItem]="tax"
        (saveClick)="saveTaxChanges($event)"
        (deleteClick)="deleteTax(tax._id)"
        [isLoading]="((isSaving(tax._id) | async) ?? false) || ((isDeleting(tax._id) | async) ?? false)"
      >
      </lh-dashboard-taxes-card>
    </ng-container>

    <!-- Display the draft tax item if it exists -->
    <ng-container *ngIf="draft">
      <lh-dashboard-taxes-card
        class="mb-4"
        [taxItem]="draft"
        (saveClick)="saveTaxChanges($event)"
        (deleteClick)="discardDraft()"
        [isDraft]="true"
        [isLoading]="(isSavingDraft$ | async) ?? false"
      >
      </lh-dashboard-taxes-card>
    </ng-container>
  </ul>

  <!-- Loading Spinner -->
  <lh-shared-ui-spinner [visible]="(isLoading$ | async) ?? false"></lh-shared-ui-spinner>

  <!-- No Tax Items Message -->
  <div *ngIf="isTaxFeatureEnabled && (taxes$ | async)?.length === 0 && !((isLoading$ | async) ?? false)">
    <p>{{ 'NO_TAX_ADDED_YET' | translate }}</p>
  </div>

  <!-- Add Tax Button -->
  <div class="d-flex" *ngIf="isTaxFeatureEnabled && !((isLoading$ | async) ?? false)">
    <button class="btn btn-outline-secondary mx-auto" (click)="createDraft()" *ngIf="!draft">
      {{ 'ADD_TAX' | translate }}
    </button>
  </div>
</div>
